import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Views from "./views";
import "./translations/i18n";
import { useFirestoreConnect } from "react-redux-firebase";
import { FIRESTORE_INVITED_USERS_TABLE, FIRESTORE_USERS_TABLE } from "./constants/FirestoreConstant";
import { StyleProvider } from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import nlNL from "antd/lib/locale/nl_NL";
import "./assets/css/globals.css";
import "dayjs/locale/nl";
import * as dayjs from "dayjs";
import { AuthProvider } from "./data/hooks/useAuth";
import ErrorBoundary from "./components/ErrorBoundary";

dayjs.locale("nl");

const AppContent = () => {
  return (
    <StyleProvider>
      <ConfigProvider
        locale={nlNL}
        theme={{
          token: {
            colorPrimary: "#938370",
          },
          components: {
            Button: {
              colorPrimary: "#938370",
            },
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<Views />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </StyleProvider>
  );
};

const App = () => {
  // Fetch invited users and CMS users
  useFirestoreConnect([
    { collection: FIRESTORE_INVITED_USERS_TABLE },
    {
      collection: FIRESTORE_USERS_TABLE,
      where: ["role", "in", ["cmsUser", "cmsAdmin"]],
      storeAs: "cmsUsers",
    },
  ]);

  return (
    <div className="App">
      <AuthProvider>
        <ErrorBoundary>
          <AppContent />
        </ErrorBoundary>
      </AuthProvider>
    </div>
  );
};

export default App;
